import { COHORT_FIREBASE_KEYS_MAP } from 'constants/ab-tests'
import { getRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetRemoteConfigVariantData = (): void => {
  const { cohort, firebaseRemoteConfig } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || state.initialCohort,
      firebaseRemoteConfig: state.firebaseRemoteConfig,
    })),
  )

  useEffect(() => {
    const firebaseRemoteConfigKey = COHORT_FIREBASE_KEYS_MAP[cohort]
    const remoteConfigVariantValue = getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey,
    })
    useZustandStore.setState({
      firebaseRemoteConfigVariantData: remoteConfigVariantValue,
    })
  }, [firebaseRemoteConfig, cohort])
}
